import {
  CloseButton,
  Popover,
  PopoverButton,
  PopoverPanel,
} from '@headlessui/react';
import { FC } from 'react';
import EditIcon from '@/assets/edit.svg';
import RefreshIcon from '@/assets/refresh.svg';
import SettingsIcon from '@/assets/settings.svg';
import { cx } from '@/utils/cx';

export type UnitSettingsDropdownProps = {
  disabled?: boolean;
  onEdit: () => void;
  onReset: () => void;
};

export const UnitSettingsDropdown: FC<UnitSettingsDropdownProps> = ({
  disabled,
  onEdit,
  onReset,
}) => (
  <Popover className="relative">
    <PopoverButton
      aria-label="Unit options"
      className={cx('focusable', 'button button-secondary flex items-center')}
      disabled={disabled}
    >
      <SettingsIcon className="h-6" />
    </PopoverButton>
    <PopoverPanel
      transition
      anchor={{ to: 'bottom end', gap: 8 }}
      className="z-10 w-48 divide-y divide-gray-900/10 rounded-md bg-white text-sm/6 drop-shadow-sm transition duration-200 ease-in-out data-[closed]:-translate-y-1 data-[closed]:opacity-0"
    >
      <div className="p-2">
        <CloseButton
          className={cx(
            'focusable',
            'flex w-full items-center gap-2 rounded-lg px-3 py-2 transition hover:bg-gray-400/10',
          )}
          onClick={onEdit}
        >
          <EditIcon className="h-4" />
          <span className="font-semibold text-gray-500">Edit</span>
        </CloseButton>
      </div>
      <div className="p-2">
        <CloseButton
          className={cx(
            'focusable',
            'flex w-full items-center gap-2 rounded-lg px-3 py-2 text-red-600 transition hover:bg-red-50',
          )}
          onClick={onReset}
        >
          <RefreshIcon className="h-4" />
          <span className="font-semibold">Reset Unit</span>
        </CloseButton>
      </div>
    </PopoverPanel>
  </Popover>
);
